import { Grid } from "@mui/material";
import {
  BtnBaseButton,
  BtnClear,
  BtnSearch,
} from "components/Button/ButtonAll";
import { SelectItem } from "components/Input/Select/SelectItem";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import DifferenceIcon from '@mui/icons-material/Difference';
import { useEffect, useState } from "react";
import { FnAxios, FnDialog } from "utilities/utilities";
import { GetMenuPermission } from "utilities/SystemFunction";

const FilterFundActionPlan = ({ onSearch, onClear, onAddForm }) => {

  const AxiosFn = FnAxios();
  const [arrYear, setArrYear] = useState([]);
  const [nMin, setNMin] = useState(null);
  const [nMax, setNMax] = useState(null);

  const DialogFn = FnDialog();
  const [isPermission, setIsPermission] = useState<boolean>(false);

  useEffect(() => {
    GetMenuPermission(AxiosFn, setIsPermission, DialogFn);
  }, []);

  useEffect(() => {
    AxiosFn.Get(`FundActionPlan/GetFilterFundActionPlan`, {}, (result) => {
      setArrYear([...result.objResult.lstYear]);
    });
  }, [])

  return (
    <Grid item xs={12}>
      <Grid container justifyContent={"space-between"} spacing={1}>
        <Grid item xs={2}>
          {isPermission &&
            <BtnBaseButton
              txt="เพิ่มแผนปฎิบัติงาน"
              size={"medium"}
              startIcon={<DifferenceIcon />}
              IsRadius={false}
              IsDisabled={false}
              IsHidden={false}
              onClick={onAddForm}
              IsCircleWithOutText={false}
              bgcolor="#33a64c"
              bgcolorHover="#33a64c"
              fontColor="#ffffff"
              tooltipPlacement="bottom"
              id="Btn-Preview-FollowUp"
              className="Btn-Preview-FollowUp"
            />
          }
        </Grid>
        <Grid item xs={10}>
          <Grid
            container
            justifyContent={"flex-end"}
            spacing={1}
          >
            <Grid item xs={3}>
              <SelectItem
                id="sYear"
                name="sYear"
                label="ประจำปีบัญชี"
                options={arrYear}
                required={false}
                disabled={false}
              />
            </Grid>
            <Grid item xs={3}>
              <DatePickerItem
                name="sUpdateDateStart"
                label="วันที่แก้ไขเริ่มต้น"
                required={false}
                maxDate={nMax}
                onChange={(e) => {
                  if (e) {
                    setNMin(e)
                  } else {
                    setNMin(null)
                  }
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <DatePickerItem
                name="sUpdateDateEnd"
                label="วันที่แก้ไขสิ้นสุด"
                required={false}
                minDate={nMin}
                onChange={(e) => {
                  if (e) {
                    setNMax(e)
                  } else {
                    setNMax(null)
                  }
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                alignSelf: "center",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Grid item sx={{ mr: 0.5 }}>
                <BtnClear
                  id={"btnClearSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onClear}
                />
              </Grid>
              <Grid item>
                <BtnSearch
                  id={"btnSearchAll"}
                  IsCircleWithOutText={true}
                  onClick={onSearch}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterFundActionPlan;
